import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './lib/AuthContext';
import { AppLayout, MarketingLayout } from './components/layouts';
import { RequireAuth } from './components/RequireAuth';
import { LandingPage } from './pages/LandingPage';
import { PricingPage } from './pages/PricingPage';
import { PrivacyPage, TermsPage } from './pages/StaticPages';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { BillingSuccessPage, LoginPage } from './pages/LoginPage';
import { LibraryPage } from './pages/LibraryPage';
import { PhotoDetailPage } from './pages/PhotoDetailPage';
import { AccountPage } from './pages/AccountPage';
import { UpscalePage } from './pages/UpscalePage';
import { App as StudioApp } from './App';
import './styles/kinvera.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route index element={<LandingPage />} />
            <Route path="how-it-works" element={<HowItWorksPage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="login" element={<LoginPage />} />
          </Route>
          <Route
            path="app"
            element={
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            }
          >
            <Route index element={<StudioApp />} />
            <Route path="upscale" element={<UpscalePage />} />
            <Route path="library" element={<LibraryPage />} />
            <Route path="library/:jobId" element={<PhotoDetailPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="billing/success" element={<BillingSuccessPage />} />
            <Route path="integrations/google-photos" element={<StudioApp />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
